<template>
    <v-container>
        <v-row>
            <v-col lg="10" md="12" offset-lg="1" offset-xl="2" xl="8" xs="12">
                <v-card>
                    <v-img :src="event.image"></v-img>
                    <v-card-text class="text-h5">
                      Registrierung für {{ event.title}}
                    </v-card-text>
                    <v-card-subtitle>
                        <v-row>
                            <v-col title="Zeitraum">
                                <v-icon small>fa-calendar</v-icon>
                                {{ displayGermanDate(event.startDate) }} - {{ displayGermanDate(event.endDate) }}
                            </v-col>
                          <v-col title="Veranstalter">
                            <v-icon small>fa-person-sign</v-icon>
                            {{ event.hostName }}
                          </v-col>
                        </v-row>
                        <v-row class="d-flex flex-md-row flex-column-reverse pb-4">
                            <v-col cols="12" md="8" title="Beschreibung">{{ event.description}}</v-col>
                            <v-col cols="12" md="4"><v-img :src="event.logo" contain max-height="150" alt="Logo der Veranstaltung"></v-img></v-col>
                        </v-row>
                        <v-btn :href="event.announcement" target="_blank" title="Offizielle Ausschreibung">Zur offiziellen Ausschreibung</v-btn>
                    </v-card-subtitle>
                    <v-card-text>
                        <RegistrationForm :event="event" :categories="categories" v-if="isRegistrationOpen()"/>
                        <v-layout justify-center v-else-if="!isRegistrationStarted()">
                            <v-flex xs12>
                                <v-alert :value="true" type="warning">Eine Online Anmeldung ist leider noch nicht
                                    möglich. Die Anmeldung startet am {{ displayGermanDate(event.registrationStart.split(' ')[0]) }}.
                                </v-alert>
                            </v-flex>
                        </v-layout>
                        <v-layout justify-center v-else-if="!isRegistrationOpen()">
                            <v-flex xs12>
                                <v-alert :value="true" type="warning">Eine Online Anmeldung ist leider nicht mehr
                                    möglich. Eventuell sind Nachmeldungen vor Ort möglich. Details dazu finden Sie
                                    in der <a :href="event.announcement">Ausschreibung</a>.
                                </v-alert>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text href="http://www.drussen.de/impressum.html" target="_blank">Impressum</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn text href="http://www.drussen.de/datenschutz.html" target="_blank">Datenschutz</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import RegistrationForm from '@/components/RegistrationForm.vue'
    import EventService from '@/services/EventService'

    export default {
        name: 'registration',
        components: {
            RegistrationForm
        },
        data: () => ({
            event: {
                title: '',
                image: ''
            },
            categories: []
        }),
        methods: {
            isEventLoaded () {
                return this.event.registrationEnd !== undefined
            },
            isRegistrationEnded () {
                if (this.isEventLoaded()) {
                    return new Date(this.event.registrationEnd) > new Date()
                }

                return false
            },
            isRegistrationStarted () {
                if (this.isEventLoaded()) {
                    return new Date(this.event.registrationStart) < new Date()
                }

                return false
            },
            isRegistrationOpen () {
                if (this.isEventLoaded()) {
                    return new Date(this.event.registrationEnd) > new Date() && new Date(this.event.registrationStart) < new Date()
                }

                return false
            },
            displayGermanDate (date) {
                if (date !== undefined && date !== '') {
                    return date.split('-').reverse().join('.')
                }
                return ''
            }
        },
        created() {
            EventService.getEvent(this.$route.params.token).then(data => {
                this.event = data
            })
            EventService.getEventCategories(this.$route.params.token).then(data => {
                this.categories = data
            })
        }
    }
</script>
